export default "__VITE_ASSET__$oZgxeiY__"